import React from "react";
import 'intl';
import 'intl/locale-data/jsonp/en';
import FederatedResult from '../result';

// Custom class for the result component
class FederatedDirectoryResult extends FederatedResult {

  render() {
    const { doc, highlight } = this.props;
    const placeholderImage = "/themes/custom/bmc_base_theme/assets/images/placeholders/headshoticon.png";
    let departments = null;
    if (Array.isArray(doc.sm_department)){
      departments = doc.sm_department.join(" | ");
    }
    return (
      <li
        className="search-card search-card--directory tile"
        onClick={() => this.props.onSelect(doc)}
      >
        <a href={this.getCanonicalLink(doc)} >
        <div className="wrapper">
        <div className="img">
          {doc.sm_federated_image && doc.sm_federated_image.length ? (
            <picture className="aspect-ratio-2x3">
              <source
                media="(min-width:340px)"
                srcset={`${doc.sm_federated_image[0]}?io=transform:fill,width:333,height:500, ${doc.sm_federated_image[0]}?io=transform:fill,width:666,height:1000 2x`}
              />
              <img
                src={`${doc.sm_federated_image[0]}?io=transform:fill,width:166,height:250&amp;format=jpg`}
                alt=""
                style={{ width: "100%" }}
                className="aspect-ratio-2x3"
              />
            </picture>
          ) : (
            <picture className="aspect-ratio-2x3">
              <img src={placeholderImage} />
            </picture>
          )}
        </div>

        <div className="text">
          {departments ? (
            <span className="department-tag">{departments}</span>
          ) : null}

          <div className="heading-wrapper">
          // Use the sort field instead of the title field to match the sort with the title showed to the user.
          <h3 className="heading h5" dangerouslySetInnerHTML={{ __html: doc.ss_sort_az_field }} >
          </h3>

          {doc.ss_field_clinical_title && (
              <h5 className="subheading">{doc.ss_field_clinical_title}</h5>
            )}
          </div>

          <p
            className="summary"
            dangerouslySetInnerHTML={{ __html: doc.ss_summary }}
          />

          {doc.tm_X3b_en_field_special_interest && (
            <div className="tags tags--comma special-interests">
              <h5>Specialty:</h5>
              <p>
                {Array.isArray(doc.tm_X3b_en_field_special_interest) &&
                  doc.tm_X3b_en_field_special_interest.map((interest) => (
                    <span className="tag">{interest}</span>
                  ))}
              </p>
            </div>
          )}

          {(doc.bs_field_accepting_patients ||
            doc.bs_field_top_dentist ||
            doc.bs_field_top_doc) && (
            <div className="tags tags attributes">
              <p>
                {doc.bs_field_accepting_patients && (
                  <span className="tag attributes--accepting-patients">
                    <span className="visually-hidden">Accepting Patients</span>
                  </span>
                )}
                {doc.bs_field_top_dentist && (
                  <span className="tag attributes--top-dentist">
                    <span className="visually-hidden">Top Dentist</span>
                  </span>
                )}
                {doc.bs_field_top_doc && (
                  <span className="tag attributes--top-doc">
                    <span className="visually-hidden">Top Doctor</span>
                  </span>
                )}
              </p>
            </div>
          )}

          {doc.sm_field_phone && (
            <div className="tags tags--pipe phone">
              <p>
                {Array.isArray(doc.sm_field_phone) &&
                  doc.sm_field_phone.map((phone) => (
                    <a
                      className="tag"
                      href={`tel:${this.formatPhoneNumber(phone)}`}
                    >
                      {this.formatPhoneNumber(phone)}
                    </a>
                  ))}
              </p>
            </div>
          )}

          <div className="meta tags tags--pipe">
            <span className="content-type-tag type">
              {doc.sm_federated_type}
            </span>
          </div>


        </div>
        </div>
        </a>
      </li>
    );
  }
}

export default FederatedDirectoryResult;
